require('./principles/principles.component');
require('./useterms/useterms.component');
